module.exports = __webpack_public_path__ + "img/banner-ru.6096954b.jpg";